class FormOptionItem {
    Id: number;
    Name: string;
    Value: string;
    IsDefault: boolean;
    Sequence: number;
    OptionGroupId: number;

    constructor(optionGroupId: number, id: number, name: string, value: string, isDefault: boolean, sequence: number) {
        this.Id = id;
        this.Name = name;
        this.Value = value;
        this.IsDefault = isDefault;
        this.Sequence = sequence;
        this.OptionGroupId = optionGroupId;
    }
}

export default FormOptionItem;